export const authTranslations = {
  // Login page
  loginToZaviago: "เข้าสู่ระบบ Zaviago",
  loginToFrappe: "เข้าสู่ระบบ Frappe",
  loginDescriptionZaviago: "กรอกข้อมูลเพื่อเข้าถึงพื้นที่ทำงานของคุณ",
  loginDescriptionFrappe: "กรอก URL และข้อมูลเพื่อเข้าถึงข้อมูล ERPNext ของคุณ",
  frappeInstanceUrl: "URL ของ Frappe",
  frappeUrlPlaceholder: "http://127.0.0.1:8000 หรือ https://your-site.com",
  email: "อีเมล",
  username: "ชื่อผู้ใช้",
  emailPlaceholder: "you@example.com",
  usernamePlaceholder: "administrator",
  password: "รหัสผ่าน",
  passwordPlaceholder: "••••••••",
  loggingIn: "กำลังเข้าสู่ระบบ...",
  login: "เข้าสู่ระบบ",
  dontHaveAccount: "ยังไม่มีบัญชี?",
  createOne: "สร้างบัญชี",

  // Error messages
  errorFrappeUrlRequired: "กรุณากรอก URL ของ Frappe",
  errorInvalidUrl: "กรุณากรอก URL ที่ถูกต้อง เริ่มต้นด้วย http:// หรือ https://",
  errorLoginFailed: "เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบข้อมูลของคุณ",

  // Registration wizard
  back: "ย้อนกลับ",
  next: "ถัดไป",
  skip: "ข้าม",
  alreadyHaveAccount: "มีบัญชีอยู่แล้ว?",
  signIn: "เข้าสู่ระบบ",

  // Step: About You
  tellMeAboutYourself: "บอกเราเกี่ยวกับตัวคุณ",
  letsStartWithYourName: "เริ่มต้นด้วยชื่อของคุณ",
  yourName: "ชื่อของคุณ",
  namePlaceholder: "สมชาย",
  errorNameRequired: "กรุณากรอกชื่อ",
  optional: "ไม่บังคับ",

  // Intent-personalized About You headlines
  intentAboutYouHeadlineChat: "มาตั้งค่าแชทของคุณ",
  intentAboutYouSublineChat: "เราจะเตรียมกล่องข้อความให้ — คุณชื่ออะไร?",
  intentAboutYouHeadlineSelling: "มาสร้างร้านค้าของคุณ",
  intentAboutYouSublineSelling: "เราจะตั้งค่าหน้าร้าน — คุณชื่ออะไร?",
  intentAboutYouHeadlinePos: "มาตั้งค่า POS ของคุณ",
  intentAboutYouSublinePos: "เราจะตั้งค่าระบบขายหน้าร้าน — คุณชื่ออะไร?",
  intentAboutYouHeadlineCrm: "มาจัดระเบียบผู้ติดต่อของคุณ",
  intentAboutYouSublineCrm: "เราจะตั้งค่า CRM — คุณชื่ออะไร?",
  firstName: "ชื่อ",
  firstNamePlaceholder: "สมชาย",
  lastName: "นามสกุล",
  lastNamePlaceholder: "ใจดี",
  errorFirstNameRequired: "กรุณากรอกชื่อ",
  errorLastNameRequired: "กรุณากรอกนามสกุล",

  // Step: Contact
  howCanWeReachYou: "เราจะติดต่อคุณได้อย่างไร?",
  enterEmailAndPassword: "กรอกอีเมลและสร้างรหัสผ่าน",

  // Intent-personalized Contact headlines
  intentContactHeadlineChat: "สร้างบัญชีแชทของคุณ",
  intentContactSublineChat: "อีเมลนี้จะใช้เข้าสู่ระบบกล่องข้อความ",
  intentContactHeadlineSelling: "สร้างบัญชีร้านค้าของคุณ",
  intentContactSublineSelling: "อีเมลนี้จะใช้เข้าสู่ระบบแดชบอร์ด",
  intentContactHeadlinePos: "สร้างบัญชี POS ของคุณ",
  intentContactSublinePos: "อีเมลนี้จะใช้เข้าสู่ระบบแดชบอร์ด",
  intentContactHeadlineCrm: "สร้างบัญชี CRM ของคุณ",
  intentContactSublineCrm: "อีเมลนี้จะใช้เข้าสู่ระบบแดชบอร์ด",
  minimumCharacters: "อย่างน้อย 8 ตัวอักษร",
  errorEmailRequired: "กรุณากรอกอีเมล",
  errorEmailInvalid: "กรุณากรอกอีเมลที่ถูกต้อง",
  errorPasswordRequired: "กรุณากรอกรหัสผ่าน",
  errorPasswordMinLength: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",

  // Step: Company
  whatsYourCompanyCalled: "บริษัทของคุณชื่ออะไร?",
  workspaceName: "นี่จะเป็นชื่อพื้นที่ทำงานของคุณ",
  companyName: "ชื่อบริษัท",
  companyNamePlaceholder: "บริษัท ABC จำกัด",
  errorCompanyNameRequired: "กรุณากรอกชื่อบริษัท",
  errorCompanyNameMinLength: "ชื่อบริษัทต้องมีอย่างน้อย 2 ตัวอักษร",
  errorCompanyNameMaxLength: "ชื่อบริษัทต้องไม่เกิน 50 ตัวอักษร",
  errorCompanyNameInvalidChars: "ชื่อบริษัทไม่สามารถมีอักขระ < > / \\ \" ` ; | { } [ ]",

  // Step: Phone
  whatsYourPhoneNumber: "เบอร์โทรศัพท์ของคุณคืออะไร?",
  phoneOptional: "ไม่บังคับ - สำหรับกู้คืนบัญชีและการแจ้งเตือน",
  phoneNumber: "เบอร์โทรศัพท์",
  phoneNumberPlaceholder: "081 234 5678",

  // Step: Business Type
  whatTypeOfBusiness: "คุณทำธุรกิจประเภทใด?",
  businessTypeOptional: "ไม่บังคับ - ช่วยให้เราปรับแต่งประสบการณ์ของคุณ",
  searchBusinessTypes: "ค้นหาประเภทธุรกิจ...",
  noResultsFound: "ไม่พบผลลัพธ์",

  // Step: App Interests
  whichAppsToTry: "คุณต้องการลองใช้แอปใดบ้าง?",
  appInterestsOptional: "ไม่บังคับ - เลือกฟีเจอร์ที่คุณสนใจ",
  loadingApps: "กำลังโหลดแอป...",
  creatingWorkspace: "กำลังสร้างพื้นที่ทำงานของคุณ...",
  startFreeTrial: "เริ่มทดลองใช้ฟรี",

  // General
  loading: "กำลังโหลด...",
  registrationFailed: "การลงทะเบียนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",

  // SMS OTP
  verifyYourPhone: 'ยืนยันหมายเลขโทรศัพท์ของคุณ',
  otpDescription: 'เราจะส่งรหัสยืนยันทาง SMS',
  sendOtpCode: 'ส่งรหัสยืนยัน',
  sendingOtp: 'กำลังส่ง...',
  enterVerificationCode: 'กรอกรหัสยืนยัน',
  otpSentTo: 'ส่งรหัสไปที่',
  otpRefCode: 'อ้างอิง',
  verifyCode: 'ยืนยัน',
  verifyingCode: 'กำลังยืนยัน...',
  resendCode: 'ส่งรหัสอีกครั้ง',
  resendIn: 'ส่งอีกครั้งใน',
  changeNumber: 'เปลี่ยนหมายเลข',
  phoneVerified: 'ยืนยันหมายเลขแล้ว',
  errorPhoneRequired: 'กรุณากรอกหมายเลขโทรศัพท์',
  errorPhoneInvalid: 'กรุณากรอกหมายเลขโทรศัพท์มือถือไทยที่ถูกต้อง',
  errorOtpExpired: 'รหัสหมดอายุ กรุณาขอรหัสใหม่',
  errorOtpInvalid: 'รหัสไม่ถูกต้อง กรุณาลองอีกครั้ง',
  errorTooManyOtp: 'ส่งรหัสมากเกินไป กรุณารอ 10 นาที',

  // Login method selection (mobile-first)
  welcomeBack: "ยินดีต้อนรับกลับ",
  heroHeadline: "แอปเดียว จัดการธุรกิจครบวงจร",
  heroSubline: "ขาย สต๊อก แชท สะสมแต้ม และอื่นๆ รวมไว้ในที่เดียว",
  chooseSignInMethod: "เลือกวิธีเข้าสู่ระบบ",
  createAccount: "สร้างบัญชีของคุณ",
  chooseSignUpMethod: "เลือกวิธีสมัครสมาชิก",
  continueWithEmail: "เข้าสู่ระบบด้วยอีเมล",
  loginWithEmail: "เข้าสู่ระบบด้วยอีเมล",
  enterYourCredentials: "กรอกอีเมลและรหัสผ่านของคุณ",

  // Google Login
  continueWithGoogle: "ดำเนินการต่อด้วย Google",
  googleLoginFailed: "การเข้าสู่ระบบ Google ล้มเหลว",
  googleLoginProcessing: "กำลังดำเนินการเข้าสู่ระบบ Google...",

  // LINE Login
  orContinueWith: "หรือดำเนินการต่อด้วย",
  continueWithLine: "ดำเนินการต่อด้วย LINE",
  lineLoginFailed: "การเข้าสู่ระบบ LINE ล้มเหลว",
  lineLoginProcessing: "กำลังดำเนินการเข้าสู่ระบบ LINE...",
  lineCallbackInvalid: "Callback ไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่",
  lineStateInvalid: "การตรวจสอบความปลอดภัยล้มเหลว กรุณาเข้าสู่ระบบใหม่",
  backToLogin: "กลับไปหน้าเข้าสู่ระบบ",

  // === Intent-specific qualification steps (Phase 3) ===

  // Chat intent: channels
  chatChannelsTitle: "เลือกช่องทางที่คุณสนใจจะใช้งาน",
  chatChannelsSubtitle: "เลือกได้หลายช่องทาง",
  chatChannelLineOA: "LINE Official Account",
  chatChannelFacebook: "Facebook Messenger",
  chatChannelInstagram: "Instagram DM",
  chatChannelWebsite: "แชทบนเว็บไซต์",
  chatChannelWhatsApp: "WhatsApp",
  chatChannelTelegram: "Telegram",
  chatChannelEmail: "อีเมล",
  chatChannelTwitter: "X (Twitter)",
  chatChannelOther: "ช่องทางอื่น",

  // Chat intent: volume
  chatVolumeTitle: "มีข้อความเข้ามาวันละประมาณเท่าไหร่?",
  chatVolumeSubtitle: "จำนวนข้อความที่ได้รับต่อวันโดยประมาณ",
  chatVolumeUnder50: "น้อยกว่า 50",
  chatVolume50to200: "50 – 200",
  chatVolume200to500: "200 – 500",
  chatVolumeOver500: "500+",

  // Selling intent: category
  sellingCategoryTitle: "คุณขายสินค้าประเภทไหน?",
  sellingCategorySubtitle: "ช่วยให้เราตั้งค่าร้านค้าออนไลน์ของคุณ",
  sellingCatFashion: "แฟชั่นและเครื่องแต่งกาย",
  sellingCatFood: "อาหารและเครื่องดื่ม",
  sellingCatBeauty: "ความงามและเครื่องสำอาง",
  sellingCatElectronics: "อิเล็กทรอนิกส์และแกดเจ็ต",
  sellingCatHome: "ของใช้ในบ้าน",
  sellingCatOther: "อื่นๆ",

  // Selling intent: channels
  sellingChannelsTitle: "ขายผ่านช่องทางไหนบ้าง?",
  sellingChannelsSubtitle: "เลือกทุกช่องทางที่คุณขาย",
  sellingChOwnWebsite: "เว็บไซต์ของตัวเอง",
  sellingChShopee: "Shopee",
  sellingChLazada: "Lazada",
  sellingChTikTok: "TikTok Shop",
  sellingChLine: "LINE",
  sellingChFacebook: "Facebook",
  sellingChInstagram: "Instagram",
  sellingChOffline: "หน้าร้าน",

  // POS intent: store type
  posTypeTitle: "ร้านของคุณเป็นแบบไหน?",
  posTypeSubtitle: "ช่วยให้เราตั้งค่า POS ของคุณ",
  posTypeCafe: "คาเฟ่ / ร้านกาแฟ",
  posTypeRestaurant: "ร้านอาหาร",
  posTypeRetail: "ร้านค้าปลีก",
  posTypeService: "บริการ (ร้านเสริมสวย, สปา ฯลฯ)",
  posTypeOther: "อื่นๆ",

  // POS intent: branches
  posBranchesTitle: "คุณมีสาขากี่แห่ง?",
  posBranchesSubtitle: "รวมสาขาหลักของคุณ",
  posBranches1: "1 สาขา",
  posBranches2to5: "2 – 5 สาขา",
  posBranches6to20: "6 – 20 สาขา",
  posBranchesOver20: "มากกว่า 20 สาขา",

  // CRM intent: team size
  crmTeamSizeTitle: "ทีมขายมีกี่คน?",
  crmTeamSizeSubtitle: "คนที่ดูแลลูกค้าสัมพันธ์",
  crmTeamSolo: "แค่คนเดียว",
  crmTeam2to5: "2 – 5 คน",
  crmTeam6to20: "6 – 20 คน",
  crmTeamOver20: "มากกว่า 20 คน",

  // CRM intent: current tool
  crmCurrentToolTitle: "ตอนนี้ใช้อะไรจัดการลูกค้า?",
  crmCurrentToolSubtitle: "เครื่องมือปัจจุบันของคุณ — เราจะช่วยย้ายข้อมูล",
  crmToolExcel: "Excel / Google Sheets",
  crmToolLineNotes: "แชท LINE / แอปจดโน้ต",
  crmToolCrmApp: "แอป CRM อื่น",
  crmToolNothing: "ยังไม่ได้ใช้อะไร",

  // === Desktop Handoff (Phase 4) ===
  desktopHandoffTitle: "ต้องการใช้งานต่อบนคอมพิวเตอร์ไหม?",
  desktopHandoffSubtitle: "กรอกอีเมลแล้วเราจะส่งลิงก์เข้าสู่ระบบให้ — เปิดบนคอมพิวเตอร์เพื่อเริ่มต้นใช้งานทันที",
  desktopHandoffEmailPlaceholder: "อีเมลของคุณ@email.com",
  desktopHandoffSendLink: "ส่งลิงก์ให้ฉัน",
  desktopHandoffSkip: "ข้าม — ใช้งานบนมือถือต่อ",
  desktopHandoffEmailRequired: "กรุณากรอกอีเมล",
  desktopHandoffEmailInvalid: "กรุณากรอกอีเมลที่ถูกต้อง",
  desktopHandoffLineEmailNudge: "กรุณาใช้อีเมลส่วนตัวหรืออีเมลงาน — ไม่ใช่อีเมล LINE",
} as const;
